import AnnouncementBanner from './components/AnnouncementBanner';
import Navigation from './components/Navigation';
import CookieConsent from './components/CookieConsent';
import Hero from './sections/Hero';
import ProductsShowcase from './sections/ProductsShowcase';
import StatsBar from './sections/StatsBar';
import Testimonials from './sections/Testimonials';
import AdvisorQuote from './sections/AdvisorQuote';
import HowItWorks from './sections/HowItWorks';
import Features from './sections/Features';
import PartnerMarquee from './sections/PartnerMarquee';
import SpecialtyTabs from './sections/SpecialtyTabs';
import ComplianceBadges from './sections/ComplianceBadges';
import FounderVideo from './sections/FounderVideo';
import Pricing from './sections/Pricing';
import FAQ from './sections/FAQ';
import FollowUs from './sections/FollowUs';
import FinalCTA from './sections/FinalCTA';
import Footer from './components/Footer';
// dependencies
export default function App() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <AnnouncementBanner />
      <Navigation />
      <main>
        <Hero />
        <ProductsShowcase />
        <StatsBar />
        <Testimonials />
        <AdvisorQuote />
        <HowItWorks />
        <section id="features"><Features /></section>
        <PartnerMarquee />
        <section id="specialties"><SpecialtyTabs /></section>
        <ComplianceBadges />
        <FounderVideo />
        <Pricing />
        <FAQ />
        <FollowUs />
        <FinalCTA />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
